/**
 * ISO 3166-1 alpha-2 country codes with display names.
 *
 * Source: https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/blob/master/all/all.json
 */

export interface Country {
    code: string;
    name: string;
    /* Pre-lowercased name for performant filtering */
    nameLower: string;
}

export const COUNTRIES: Country[] = [
    { name: 'Afghanistan', nameLower: 'afghanistan', code: 'AF' },
    { name: 'Åland Islands', nameLower: 'åland islands', code: 'AX' },
    { name: 'Albania', nameLower: 'albania', code: 'AL' },
    { name: 'Algeria', nameLower: 'algeria', code: 'DZ' },
    { name: 'American Samoa', nameLower: 'american samoa', code: 'AS' },
    { name: 'Andorra', nameLower: 'andorra', code: 'AD' },
    { name: 'Angola', nameLower: 'angola', code: 'AO' },
    { name: 'Anguilla', nameLower: 'anguilla', code: 'AI' },
    { name: 'Antarctica', nameLower: 'antarctica', code: 'AQ' },
    {
        name: 'Antigua and Barbuda',
        nameLower: 'antigua and barbuda',
        code: 'AG',
    },
    { name: 'Argentina', nameLower: 'argentina', code: 'AR' },
    { name: 'Armenia', nameLower: 'armenia', code: 'AM' },
    { name: 'Aruba', nameLower: 'aruba', code: 'AW' },
    { name: 'Australia', nameLower: 'australia', code: 'AU' },
    { name: 'Austria', nameLower: 'austria', code: 'AT' },
    { name: 'Azerbaijan', nameLower: 'azerbaijan', code: 'AZ' },
    { name: 'Bahamas', nameLower: 'bahamas', code: 'BS' },
    { name: 'Bahrain', nameLower: 'bahrain', code: 'BH' },
    { name: 'Bangladesh', nameLower: 'bangladesh', code: 'BD' },
    { name: 'Barbados', nameLower: 'barbados', code: 'BB' },
    { name: 'Belarus', nameLower: 'belarus', code: 'BY' },
    { name: 'Belgium', nameLower: 'belgium', code: 'BE' },
    { name: 'Belize', nameLower: 'belize', code: 'BZ' },
    { name: 'Benin', nameLower: 'benin', code: 'BJ' },
    { name: 'Bermuda', nameLower: 'bermuda', code: 'BM' },
    { name: 'Bhutan', nameLower: 'bhutan', code: 'BT' },
    {
        name: 'Bolivia, Plurinational State of',
        nameLower: 'bolivia, plurinational state of',
        code: 'BO',
    },
    {
        name: 'Bonaire, Sint Eustatius and Saba',
        nameLower: 'bonaire, sint eustatius and saba',
        code: 'BQ',
    },
    {
        name: 'Bosnia and Herzegovina',
        nameLower: 'bosnia and herzegovina',
        code: 'BA',
    },
    { name: 'Botswana', nameLower: 'botswana', code: 'BW' },
    { name: 'Bouvet Island', nameLower: 'bouvet island', code: 'BV' },
    { name: 'Brazil', nameLower: 'brazil', code: 'BR' },
    {
        name: 'British Indian Ocean Territory',
        nameLower: 'british indian ocean territory',
        code: 'IO',
    },
    { name: 'Brunei Darussalam', nameLower: 'brunei darussalam', code: 'BN' },
    { name: 'Bulgaria', nameLower: 'bulgaria', code: 'BG' },
    { name: 'Burkina Faso', nameLower: 'burkina faso', code: 'BF' },
    { name: 'Burundi', nameLower: 'burundi', code: 'BI' },
    { name: 'Cabo Verde', nameLower: 'cabo verde', code: 'CV' },
    { name: 'Cambodia', nameLower: 'cambodia', code: 'KH' },
    { name: 'Cameroon', nameLower: 'cameroon', code: 'CM' },
    { name: 'Canada', nameLower: 'canada', code: 'CA' },
    { name: 'Cayman Islands', nameLower: 'cayman islands', code: 'KY' },
    {
        name: 'Central African Republic',
        nameLower: 'central african republic',
        code: 'CF',
    },
    { name: 'Chad', nameLower: 'chad', code: 'TD' },
    { name: 'Chile', nameLower: 'chile', code: 'CL' },
    { name: 'China', nameLower: 'china', code: 'CN' },
    { name: 'Christmas Island', nameLower: 'christmas island', code: 'CX' },
    {
        name: 'Cocos (Keeling) Islands',
        nameLower: 'cocos (keeling) islands',
        code: 'CC',
    },
    { name: 'Colombia', nameLower: 'colombia', code: 'CO' },
    { name: 'Comoros', nameLower: 'comoros', code: 'KM' },
    { name: 'Congo', nameLower: 'congo', code: 'CG' },
    {
        name: 'Congo, Democratic Republic of the',
        nameLower: 'congo, democratic republic of the',
        code: 'CD',
    },
    { name: 'Cook Islands', nameLower: 'cook islands', code: 'CK' },
    { name: 'Costa Rica', nameLower: 'costa rica', code: 'CR' },
    { name: "Côte d'Ivoire", nameLower: "côte d'ivoire", code: 'CI' },
    { name: 'Croatia', nameLower: 'croatia', code: 'HR' },
    { name: 'Cuba', nameLower: 'cuba', code: 'CU' },
    { name: 'Curaçao', nameLower: 'curaçao', code: 'CW' },
    { name: 'Cyprus', nameLower: 'cyprus', code: 'CY' },
    { name: 'Czechia', nameLower: 'czechia', code: 'CZ' },
    { name: 'Denmark', nameLower: 'denmark', code: 'DK' },
    { name: 'Djibouti', nameLower: 'djibouti', code: 'DJ' },
    { name: 'Dominica', nameLower: 'dominica', code: 'DM' },
    { name: 'Dominican Republic', nameLower: 'dominican republic', code: 'DO' },
    { name: 'Ecuador', nameLower: 'ecuador', code: 'EC' },
    { name: 'Egypt', nameLower: 'egypt', code: 'EG' },
    { name: 'El Salvador', nameLower: 'el salvador', code: 'SV' },
    { name: 'Equatorial Guinea', nameLower: 'equatorial guinea', code: 'GQ' },
    { name: 'Eritrea', nameLower: 'eritrea', code: 'ER' },
    { name: 'Estonia', nameLower: 'estonia', code: 'EE' },
    { name: 'Eswatini', nameLower: 'eswatini', code: 'SZ' },
    { name: 'Ethiopia', nameLower: 'ethiopia', code: 'ET' },
    {
        name: 'Falkland Islands (Malvinas)',
        nameLower: 'falkland islands (malvinas)',
        code: 'FK',
    },
    { name: 'Faroe Islands', nameLower: 'faroe islands', code: 'FO' },
    { name: 'Fiji', nameLower: 'fiji', code: 'FJ' },
    { name: 'Finland', nameLower: 'finland', code: 'FI' },
    { name: 'France', nameLower: 'france', code: 'FR' },
    { name: 'French Guiana', nameLower: 'french guiana', code: 'GF' },
    { name: 'French Polynesia', nameLower: 'french polynesia', code: 'PF' },
    {
        name: 'French Southern Territories',
        nameLower: 'french southern territories',
        code: 'TF',
    },
    { name: 'Gabon', nameLower: 'gabon', code: 'GA' },
    { name: 'Gambia', nameLower: 'gambia', code: 'GM' },
    { name: 'Georgia', nameLower: 'georgia', code: 'GE' },
    { name: 'Germany', nameLower: 'germany', code: 'DE' },
    { name: 'Ghana', nameLower: 'ghana', code: 'GH' },
    { name: 'Gibraltar', nameLower: 'gibraltar', code: 'GI' },
    { name: 'Greece', nameLower: 'greece', code: 'GR' },
    { name: 'Greenland', nameLower: 'greenland', code: 'GL' },
    { name: 'Grenada', nameLower: 'grenada', code: 'GD' },
    { name: 'Guadeloupe', nameLower: 'guadeloupe', code: 'GP' },
    { name: 'Guam', nameLower: 'guam', code: 'GU' },
    { name: 'Guatemala', nameLower: 'guatemala', code: 'GT' },
    { name: 'Guernsey', nameLower: 'guernsey', code: 'GG' },
    { name: 'Guinea', nameLower: 'guinea', code: 'GN' },
    { name: 'Guinea-Bissau', nameLower: 'guinea-bissau', code: 'GW' },
    { name: 'Guyana', nameLower: 'guyana', code: 'GY' },
    { name: 'Haiti', nameLower: 'haiti', code: 'HT' },
    {
        name: 'Heard Island and McDonald Islands',
        nameLower: 'heard island and mcdonald islands',
        code: 'HM',
    },
    { name: 'Holy See', nameLower: 'holy see', code: 'VA' },
    { name: 'Honduras', nameLower: 'honduras', code: 'HN' },
    { name: 'Hong Kong', nameLower: 'hong kong', code: 'HK' },
    { name: 'Hungary', nameLower: 'hungary', code: 'HU' },
    { name: 'Iceland', nameLower: 'iceland', code: 'IS' },
    { name: 'India', nameLower: 'india', code: 'IN' },
    { name: 'Indonesia', nameLower: 'indonesia', code: 'ID' },
    {
        name: 'Iran, Islamic Republic of',
        nameLower: 'iran, islamic republic of',
        code: 'IR',
    },
    { name: 'Iraq', nameLower: 'iraq', code: 'IQ' },
    { name: 'Ireland', nameLower: 'ireland', code: 'IE' },
    { name: 'Isle of Man', nameLower: 'isle of man', code: 'IM' },
    { name: 'Israel', nameLower: 'israel', code: 'IL' },
    { name: 'Italy', nameLower: 'italy', code: 'IT' },
    { name: 'Jamaica', nameLower: 'jamaica', code: 'JM' },
    { name: 'Japan', nameLower: 'japan', code: 'JP' },
    { name: 'Jersey', nameLower: 'jersey', code: 'JE' },
    { name: 'Jordan', nameLower: 'jordan', code: 'JO' },
    { name: 'Kazakhstan', nameLower: 'kazakhstan', code: 'KZ' },
    { name: 'Kenya', nameLower: 'kenya', code: 'KE' },
    { name: 'Kiribati', nameLower: 'kiribati', code: 'KI' },
    {
        name: "Korea, Democratic People's Republic of",
        nameLower: "korea, democratic people's republic of",
        code: 'KP',
    },
    { name: 'Korea, Republic of', nameLower: 'korea, republic of', code: 'KR' },
    { name: 'Kuwait', nameLower: 'kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', nameLower: 'kyrgyzstan', code: 'KG' },
    {
        name: "Lao People's Democratic Republic",
        nameLower: "lao people's democratic republic",
        code: 'LA',
    },
    { name: 'Latvia', nameLower: 'latvia', code: 'LV' },
    { name: 'Lebanon', nameLower: 'lebanon', code: 'LB' },
    { name: 'Lesotho', nameLower: 'lesotho', code: 'LS' },
    { name: 'Liberia', nameLower: 'liberia', code: 'LR' },
    { name: 'Libya', nameLower: 'libya', code: 'LY' },
    { name: 'Liechtenstein', nameLower: 'liechtenstein', code: 'LI' },
    { name: 'Lithuania', nameLower: 'lithuania', code: 'LT' },
    { name: 'Luxembourg', nameLower: 'luxembourg', code: 'LU' },
    { name: 'Macao', nameLower: 'macao', code: 'MO' },
    { name: 'Madagascar', nameLower: 'madagascar', code: 'MG' },
    { name: 'Malawi', nameLower: 'malawi', code: 'MW' },
    { name: 'Malaysia', nameLower: 'malaysia', code: 'MY' },
    { name: 'Maldives', nameLower: 'maldives', code: 'MV' },
    { name: 'Mali', nameLower: 'mali', code: 'ML' },
    { name: 'Malta', nameLower: 'malta', code: 'MT' },
    { name: 'Marshall Islands', nameLower: 'marshall islands', code: 'MH' },
    { name: 'Martinique', nameLower: 'martinique', code: 'MQ' },
    { name: 'Mauritania', nameLower: 'mauritania', code: 'MR' },
    { name: 'Mauritius', nameLower: 'mauritius', code: 'MU' },
    { name: 'Mayotte', nameLower: 'mayotte', code: 'YT' },
    { name: 'Mexico', nameLower: 'mexico', code: 'MX' },
    {
        name: 'Micronesia, Federated States of',
        nameLower: 'micronesia, federated states of',
        code: 'FM',
    },
    {
        name: 'Moldova, Republic of',
        nameLower: 'moldova, republic of',
        code: 'MD',
    },
    { name: 'Monaco', nameLower: 'monaco', code: 'MC' },
    { name: 'Mongolia', nameLower: 'mongolia', code: 'MN' },
    { name: 'Montenegro', nameLower: 'montenegro', code: 'ME' },
    { name: 'Montserrat', nameLower: 'montserrat', code: 'MS' },
    { name: 'Morocco', nameLower: 'morocco', code: 'MA' },
    { name: 'Mozambique', nameLower: 'mozambique', code: 'MZ' },
    { name: 'Myanmar', nameLower: 'myanmar', code: 'MM' },
    { name: 'Namibia', nameLower: 'namibia', code: 'NA' },
    { name: 'Nauru', nameLower: 'nauru', code: 'NR' },
    { name: 'Nepal', nameLower: 'nepal', code: 'NP' },
    {
        name: 'Netherlands, Kingdom of the',
        nameLower: 'netherlands, kingdom of the',
        code: 'NL',
    },
    { name: 'New Caledonia', nameLower: 'new caledonia', code: 'NC' },
    { name: 'New Zealand', nameLower: 'new zealand', code: 'NZ' },
    { name: 'Nicaragua', nameLower: 'nicaragua', code: 'NI' },
    { name: 'Niger', nameLower: 'niger', code: 'NE' },
    { name: 'Nigeria', nameLower: 'nigeria', code: 'NG' },
    { name: 'Niue', nameLower: 'niue', code: 'NU' },
    { name: 'Norfolk Island', nameLower: 'norfolk island', code: 'NF' },
    { name: 'North Macedonia', nameLower: 'north macedonia', code: 'MK' },
    {
        name: 'Northern Mariana Islands',
        nameLower: 'northern mariana islands',
        code: 'MP',
    },
    { name: 'Norway', nameLower: 'norway', code: 'NO' },
    { name: 'Oman', nameLower: 'oman', code: 'OM' },
    { name: 'Pakistan', nameLower: 'pakistan', code: 'PK' },
    { name: 'Palau', nameLower: 'palau', code: 'PW' },
    {
        name: 'Palestine, State of',
        nameLower: 'palestine, state of',
        code: 'PS',
    },
    { name: 'Panama', nameLower: 'panama', code: 'PA' },
    { name: 'Papua New Guinea', nameLower: 'papua new guinea', code: 'PG' },
    { name: 'Paraguay', nameLower: 'paraguay', code: 'PY' },
    { name: 'Peru', nameLower: 'peru', code: 'PE' },
    { name: 'Philippines', nameLower: 'philippines', code: 'PH' },
    { name: 'Pitcairn', nameLower: 'pitcairn', code: 'PN' },
    { name: 'Poland', nameLower: 'poland', code: 'PL' },
    { name: 'Portugal', nameLower: 'portugal', code: 'PT' },
    { name: 'Puerto Rico', nameLower: 'puerto rico', code: 'PR' },
    { name: 'Qatar', nameLower: 'qatar', code: 'QA' },
    { name: 'Réunion', nameLower: 'réunion', code: 'RE' },
    { name: 'Romania', nameLower: 'romania', code: 'RO' },
    { name: 'Russian Federation', nameLower: 'russian federation', code: 'RU' },
    { name: 'Rwanda', nameLower: 'rwanda', code: 'RW' },
    { name: 'Saint Barthélemy', nameLower: 'saint barthélemy', code: 'BL' },
    {
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        nameLower: 'saint helena, ascension and tristan da cunha',
        code: 'SH',
    },
    {
        name: 'Saint Kitts and Nevis',
        nameLower: 'saint kitts and nevis',
        code: 'KN',
    },
    { name: 'Saint Lucia', nameLower: 'saint lucia', code: 'LC' },
    {
        name: 'Saint Martin (French part)',
        nameLower: 'saint martin (french part)',
        code: 'MF',
    },
    {
        name: 'Saint Pierre and Miquelon',
        nameLower: 'saint pierre and miquelon',
        code: 'PM',
    },
    {
        name: 'Saint Vincent and the Grenadines',
        nameLower: 'saint vincent and the grenadines',
        code: 'VC',
    },
    { name: 'Samoa', nameLower: 'samoa', code: 'WS' },
    { name: 'San Marino', nameLower: 'san marino', code: 'SM' },
    {
        name: 'Sao Tome and Principe',
        nameLower: 'sao tome and principe',
        code: 'ST',
    },
    { name: 'Saudi Arabia', nameLower: 'saudi arabia', code: 'SA' },
    { name: 'Senegal', nameLower: 'senegal', code: 'SN' },
    { name: 'Serbia', nameLower: 'serbia', code: 'RS' },
    { name: 'Seychelles', nameLower: 'seychelles', code: 'SC' },
    { name: 'Sierra Leone', nameLower: 'sierra leone', code: 'SL' },
    { name: 'Singapore', nameLower: 'singapore', code: 'SG' },
    {
        name: 'Sint Maarten (Dutch part)',
        nameLower: 'sint maarten (dutch part)',
        code: 'SX',
    },
    { name: 'Slovakia', nameLower: 'slovakia', code: 'SK' },
    { name: 'Slovenia', nameLower: 'slovenia', code: 'SI' },
    { name: 'Solomon Islands', nameLower: 'solomon islands', code: 'SB' },
    { name: 'Somalia', nameLower: 'somalia', code: 'SO' },
    { name: 'South Africa', nameLower: 'south africa', code: 'ZA' },
    {
        name: 'South Georgia and the South Sandwich Islands',
        nameLower: 'south georgia and the south sandwich islands',
        code: 'GS',
    },
    { name: 'South Sudan', nameLower: 'south sudan', code: 'SS' },
    { name: 'Spain', nameLower: 'spain', code: 'ES' },
    { name: 'Sri Lanka', nameLower: 'sri lanka', code: 'LK' },
    { name: 'Sudan', nameLower: 'sudan', code: 'SD' },
    { name: 'Suriname', nameLower: 'suriname', code: 'SR' },
    {
        name: 'Svalbard and Jan Mayen',
        nameLower: 'svalbard and jan mayen',
        code: 'SJ',
    },
    { name: 'Sweden', nameLower: 'sweden', code: 'SE' },
    { name: 'Switzerland', nameLower: 'switzerland', code: 'CH' },
    {
        name: 'Syrian Arab Republic',
        nameLower: 'syrian arab republic',
        code: 'SY',
    },
    {
        name: 'Taiwan, Province of China',
        nameLower: 'taiwan, province of china',
        code: 'TW',
    },
    { name: 'Tajikistan', nameLower: 'tajikistan', code: 'TJ' },
    {
        name: 'Tanzania, United Republic of',
        nameLower: 'tanzania, united republic of',
        code: 'TZ',
    },
    { name: 'Thailand', nameLower: 'thailand', code: 'TH' },
    { name: 'Timor-Leste', nameLower: 'timor-leste', code: 'TL' },
    { name: 'Togo', nameLower: 'togo', code: 'TG' },
    { name: 'Tokelau', nameLower: 'tokelau', code: 'TK' },
    { name: 'Tonga', nameLower: 'tonga', code: 'TO' },
    {
        name: 'Trinidad and Tobago',
        nameLower: 'trinidad and tobago',
        code: 'TT',
    },
    { name: 'Tunisia', nameLower: 'tunisia', code: 'TN' },
    { name: 'Türkiye', nameLower: 'türkiye', code: 'TR' },
    { name: 'Turkmenistan', nameLower: 'turkmenistan', code: 'TM' },
    {
        name: 'Turks and Caicos Islands',
        nameLower: 'turks and caicos islands',
        code: 'TC',
    },
    { name: 'Tuvalu', nameLower: 'tuvalu', code: 'TV' },
    { name: 'Uganda', nameLower: 'uganda', code: 'UG' },
    { name: 'Ukraine', nameLower: 'ukraine', code: 'UA' },
    {
        name: 'United Arab Emirates',
        nameLower: 'united arab emirates',
        code: 'AE',
    },
    {
        name: 'United Kingdom of Great Britain and Northern Ireland',
        nameLower: 'united kingdom of great britain and northern ireland',
        code: 'GB',
    },
    {
        name: 'United States of America',
        nameLower: 'united states of america',
        code: 'US',
    },
    {
        name: 'United States Minor Outlying Islands',
        nameLower: 'united states minor outlying islands',
        code: 'UM',
    },
    { name: 'Uruguay', nameLower: 'uruguay', code: 'UY' },
    { name: 'Uzbekistan', nameLower: 'uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', nameLower: 'vanuatu', code: 'VU' },
    {
        name: 'Venezuela, Bolivarian Republic of',
        nameLower: 'venezuela, bolivarian republic of',
        code: 'VE',
    },
    { name: 'Viet Nam', nameLower: 'viet nam', code: 'VN' },
    {
        name: 'Virgin Islands (British)',
        nameLower: 'virgin islands (british)',
        code: 'VG',
    },
    {
        name: 'Virgin Islands (U.S.)',
        nameLower: 'virgin islands (u.s.)',
        code: 'VI',
    },
    { name: 'Wallis and Futuna', nameLower: 'wallis and futuna', code: 'WF' },
    { name: 'Western Sahara', nameLower: 'western sahara', code: 'EH' },
    { name: 'Yemen', nameLower: 'yemen', code: 'YE' },
    { name: 'Zambia', nameLower: 'zambia', code: 'ZM' },
    { name: 'Zimbabwe', nameLower: 'zimbabwe', code: 'ZW' },
];

const COUNTRY_NAME_BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c.name]));

export const getCountryName = (code: string): string =>
    COUNTRY_NAME_BY_CODE.get(code) ?? code;
